import React from "react";

export const LOGICIEL_HOME_URL = "https://www.logiciel.com/";
export const LOGICIEL_CONTACT_URL = "https://www.logiciel.com/contact";
export const LOGICIEL_PRIVACY_URL = "https://www.logiciel.com/privacy-policy";
export const LOGICIEL_TERMS_URL = "https://www.logiciel.com/terms";
export const LOGICIEL_SUPPORT_EMAIL = "sales@logiciel.com";
export const LOGICIEL_SUPPORT_PHONE = "(510) 261-1100";

export function PublicComplianceFooter({ className = "" }) {
    return (
        <section
            className={`rounded-2xl border border-slate-200 bg-white/95 p-6 sm:p-8 shadow-sm ${className}`.trim()}
        >
            <div className="grid gap-8 lg:grid-cols-[1.4fr_1fr_1fr]">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Support</p>
                    <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-900">Talk with the Logiciel team</h2>
                    <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600">
                        Reach out for onboarding help, setup guidance, or support with QuickBooks connections and day-to-day operations.
                    </p>
                    <div className="mt-4 space-y-2 text-sm text-slate-700">
                        <p>
                            Email:{" "}
                            <a className="font-semibold text-slate-900 underline" href={`mailto:${LOGICIEL_SUPPORT_EMAIL}`}>
                                {LOGICIEL_SUPPORT_EMAIL}
                            </a>
                        </p>
                        <p>Phone: <span className="font-semibold text-slate-900">{LOGICIEL_SUPPORT_PHONE}</span></p>
                        <p>Support hours: Monday-Friday, 9:00 AM-6:00 PM Pacific Time.</p>
                    </div>
                    <div className="mt-5 flex flex-wrap gap-3">
                        <a
                            href={LOGICIEL_CONTACT_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
                        >
                            Contact Logiciel
                        </a>
                        <a
                            href={LOGICIEL_HOME_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:border-slate-400 hover:text-slate-900"
                        >
                            View product site
                        </a>
                    </div>
                </div>

                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Pricing</p>
                    <h3 className="mt-2 text-lg font-bold text-slate-900">Published pricing in USD</h3>
                    <p className="mt-3 text-sm leading-7 text-slate-600">
                        Start with a 30-day free trial. There is no setup fee, no contract, and no per-user charge.
                    </p>
                    <ul className="mt-4 space-y-2 text-sm leading-6 text-slate-700">
                        <li>$5 USD per order when the order total is over $250 USD.</li>
                        <li>2% of the order amount when the order total is $250 USD or less.</li>
                        <li>Monthly pricing ranges from a $60 USD minimum to a $900 USD maximum.</li>
                    </ul>
                </div>

                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Policies</p>
                    <h3 className="mt-2 text-lg font-bold text-slate-900">Public legal pages</h3>
                    <p className="mt-3 text-sm leading-7 text-slate-600">
                        Review the public policy pages below for how Logiciel handles terms, privacy, and service use.
                    </p>
                    <div className="mt-4 space-y-3 text-sm text-slate-700">
                        <p>
                            <a
                                href={LOGICIEL_PRIVACY_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-semibold text-slate-900 underline"
                            >
                                Privacy Policy
                            </a>
                        </p>
                        <p>
                            <a
                                href={LOGICIEL_TERMS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-semibold text-slate-900 underline"
                            >
                                Terms and Conditions
                            </a>
                        </p>
                    </div>
                    <p className="mt-5 text-xs leading-6 text-slate-500">
                        Intuit and QuickBooks are registered trademarks of Intuit Inc. Used with permission.
                    </p>
                </div>
            </div>
        </section>
    );
}
